"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("../../index");
var styles_1 = require("./styles");
function ToggleButton(props) {
    var _a = (0, index_1.useDropdown)(), setIsMenuOpen = _a.setIsMenuOpen, setTriggerButtonElement = _a.setTriggerButtonElement, setTriggerButtonRef = _a.setTriggerButtonRef;
    var children = props.default
        ? __spreadArray([], new Array(3), true).map(function (_, index) { return react_1.default.createElement(styles_1.Dot, { key: index }); })
        : props.children;
    return (react_1.default.createElement(styles_1.Button, { default: props.default, ref: function (reference) {
            setTriggerButtonElement(reference);
            return setTriggerButtonRef(reference);
        }, onClick: function (event) {
            event.stopPropagation();
            event.preventDefault();
            setIsMenuOpen(true);
        }, style: props.style, className: props.className }, children));
}
exports.default = ToggleButton;
//# sourceMappingURL=index.js.map